import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { SlidersHorizontal, Music, Activity, GitBranch, PackageOpen, ScanSearch } from 'lucide-react';
import TunerPanel from './warroom/TunerPanel';
import AudioPanel from './warroom/AudioPanel';
import MonitorPanel from './warroom/MonitorPanel';
import VersionTree from './warroom/VersionTree';
import ExportPanel from './warroom/ExportPanel';
import StructurePanel from './warroom/StructurePanel';

const TABS = [
  { id: 'tuner', icon: SlidersHorizontal, label: 'Tuner' },
  { id: 'audio', icon: Music, label: 'Audio' },
  { id: 'monitor', icon: Activity, label: 'Debug' },
  { id: 'versions', icon: GitBranch, label: 'Git' },
  { id: 'export', icon: PackageOpen, label: 'Export' },
  { id: 'struct', icon: ScanSearch, label: 'Codice' },
];

export default function WarRoom(props) {
  return (
    <div data-testid="war-room" className="glass lg:rounded-2xl h-full flex flex-col min-h-0">
      <div className="px-4 pt-3 pb-2 flex items-center justify-between">
        <div className="text-xs font-extrabold tracking-[.2em] text-slate-100">WAR ROOM</div>
        <span className="t-label">ispezione live</span>
      </div>
      <Tabs defaultValue="tuner" className="flex-1 min-h-0 flex flex-col">
        <TabsList className="mx-3 grid grid-cols-6 h-auto bg-black/30 p-1">
          {TABS.map((t) => (
            <TabsTrigger key={t.id} value={t.id} data-testid={`warroom-tab-${t.id}`} className="flex flex-col gap-0.5 py-1.5 text-[9px] tracking-wider data-[state=active]:bg-violet-600/40 data-[state=active]:text-white">
              <t.icon className="h-4 w-4" />{t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4">
          <TabsContent value="tuner" className="mt-0"><TunerPanel {...props} /></TabsContent>
          <TabsContent value="audio" className="mt-0"><AudioPanel {...props} /></TabsContent>
          <TabsContent value="monitor" className="mt-0"><MonitorPanel {...props} /></TabsContent>
          <TabsContent value="versions" className="mt-0"><VersionTree {...props} /></TabsContent>
          <TabsContent value="export" className="mt-0"><ExportPanel {...props} /></TabsContent>
          <TabsContent value="struct" className="mt-0"><StructurePanel {...props} /></TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
